import { createSelector } from "reselect";

import { findInWidgetState } from "../utils/storeUtils";

import { resolveBinding } from "../utils/bindingUtils";

export const selectImmutable = (state, props) => {
    var widgetImmutableData;
    var immutableState;
    // var uiState;
    // var uiStateImmutable;
    var storePath = [];
    var bindTo = props.bindTo || (props.config && props.config.bindTo);
    var resolvedBindTo;

    if (!bindTo) {
        // console.log("failed binding: ");
        // console.log(props.config);
        return props;
    }

    widgetImmutableData = state.getIn(["data", props.widgetId]);

    //Implementing placeholders in bindTo property
    //Collection components should provide props.parentBindTo to collection items
    resolvedBindTo = resolveBinding(bindTo, props.parentBindTo, props.index, widgetImmutableData);

    //storePath will also be updated
    immutableState = findInWidgetState(widgetImmutableData, resolvedBindTo.split("."), storePath);

    //truePath contains properties, remains not to break old behaviour
    //TODO: use storePath without "properties"
    storePath.push("properties");

    // uiStateImmutable = state.getIn("uiState", props.widgetId, resolvedBindTo);

    return {
        data: immutableState,
        truePath: storePath,
        computedBindTo: resolvedBindTo
        //adding uiState if available
        //waiting for first use-case before activating
        //uiState: uiState
    };
};

//to be deprecated soon
export const selectByBindTo = function(state, props = {}) {
    var immutableDataProps = selectImmutable(state, props);
    //converting immutable data, if available (TS pricing table issue)
    if (immutableDataProps.data && immutableDataProps.data.toJS) {
        immutableDataProps.data = immutableDataProps.data.toJS();
    }

    //converting immutable uiState
    // if (immutableDataProps.uiState) {
    //     immutableDataProps.uiState = immutableDataProps.uiState.toJS()
    // }

    //returning raw data
    return immutableDataProps;
};

export const elementBindToSelector = createSelector(selectByBindTo, item => item);
